// extracted by mini-css-extract-plugin
export default {"resourceIcon":"ResourceIcon_resourceIcon__ed7R9"};